import React from 'react';
import LinkPicker from 'components/LinkOmniPicker/LinkPicker';
import ImageUpload from 'components/ImageUpload';
import config from '@/config';

const IconItemOptions = ({
	event,
	iconProps,
	index,
	handleSetIconProps,
	setOmniPicker,
	handlePickOmniItem,
}) => {
	const signedUrlEndpoint = `${config.baseUrl}/${event.client_id}/events/${event.id}/upload/media/signed_url`;
	const onPress = iconProps[index] && iconProps[index].onPress;
	return (
		<div className="icon-info-container">
			<div className="left column">
				<h4 className="admin-form-item-label">Icon {index + 1} Source</h4>
				<ImageUpload
					value={iconProps[index] ? iconProps[index].source : ''}
					onChange={source => handleSetIconProps('source', index, source)}
					endpoint={signedUrlEndpoint}
					imageObj={true}
					name={`icon-${index + 1}`}
				/>
			</div>
			<div className="right column">
				<h4 className="admin-form-item-label">Icon {index + 1} Link</h4>
				<LinkPicker
					onClick={() =>
						setOmniPicker({ open: true, mediaPicker: false, from: 'icons', index, onPress })
					}
					onPress={onPress}
					placeholderStr={'Select Link Target'}
					onConfirm={() => handlePickOmniItem({}, index)}
				/>
			</div>
		</div>
	);
};

export default IconItemOptions;
